// extracted by mini-css-extract-plugin
export default {"tabGroup":"_6NVK8blHQ7OqMA0DkYbrgf"};